export const bscPresaleAddress = "0xE8bDe818eB57F77e15B245D0418e7a238b2daaCF";
export const bnbUsdtAddress = "0x55d398326f99059fF775485246999027B3197955";
export const ethPresaleAddress = "0xAa3dB4C91C5c80bce8801DB0d96A431587dDba44";
export const ethUsdtAddress = "0xdAC17F958D2ee523a2206206994597C13D831ec7";
export const admin = "0x3badb3A77859e35E2f6E82D38D9ec64dCA593fC7";
export const defaultAddress = "0x3badb3A77859e35E2f6E82D38D9ec64dCA593fC7";

export const stakingAddress = "0xdda5DC0c02E6039424Ab0b633a2f74e8AB7EA812";
export const stakingTokenAddress = "0x53f1e15ed3Cea8c1d4Adc4BE2DDE4BA33715a922";
